(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .factory('ExistingContractDTO', ExistingContractDTO);

    ExistingContractDTO.$inject = ['$resource','DateUtils'];

    function ExistingContractDTO($resource, DateUtils) {
        var resourceUrl = "api/existingContractDTO/:id";

        return $resource(resourceUrl, {}, {
            'query': {method:'GET',isArray: true},
            'get': {
                method: 'GET',
                transformResponse:function(data) {
                    if(data) {
                        data = angular.fromJson(data);
                        data.contractDate = DateUtils.convertLocalDateFromServer(data.contractDate);
                    }
                    return data;
                }
            }
        });
    }
})();
